<template>
  <div class="search-item">
    <div class="select-one" @click="openDatePanel(startKey)">
      <span v-if="obj[startKey]">{{ obj[startKey].replace(/-/g, '/') }}</span>
      <span class="gray" v-else>起始日期</span>
      <i class="iconfont icon-guanbi1" @click.stop="obj[startKey]='';" v-if="obj[startKey]"></i>
      <i class="icon-xiangxia2" v-else></i>
    </div>
    <span class="line">-</span>
    <div class="select-one" @click="openDatePanel(endKey)">
      <span v-if="obj[endKey]">{{ obj[endKey].replace(/-/g, '/') }}</span>
      <span class="gray" v-else>截止日期</span>
      <i class="iconfont icon-guanbi1" @click.stop="obj[endKey]='';" v-if="obj[endKey]"></i>
      <i class="icon-xiangxia2" v-else></i>
    </div>

    <van-popup v-model="showDatePop" position="bottom" get-container="#topPanel">
      <van-datetime-picker v-if="showDatePop" v-model="currentDate" type="date" :title="title" @confirm="saveDate" @cancel="closeDatePanel" />
    </van-popup>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  props: {
    title:null,
    obj:null,
    startKey:null,
    endKey:null,
  },
  components: { },
  data() {
    return {
      showDatePop: false,
      curDateKey: '', //当前操作的时间字段
      currentDate: new Date(),
    };
  },
  mounted() {
  },
  methods: {
    // 打开时间面板
    openDatePanel(key) {
      this.curDateKey = key;
      this.currentDate = this.obj[key] ? new Date(this.obj[key].replace(/-/g, '/')) : new Date();
      this.showDatePop = true;
    },
    // 关闭时间面板
    closeDatePanel() {
      this.curDateKey = '';
      this.showDatePop = false;
    },
    // 保存选择的日期
    saveDate() {
      this.$set(this.obj, this.curDateKey, dayjs(this.currentDate).format('YYYY-MM-DD'))
      this.curDateKey = '';
      this.showDatePop = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-guanbi1 {
  color: #bbb;
}
</style>
